export const TABLE_HEAD = [
  'API Name',
  'Requests',
  'Success',
  'Errors',
  'Last Access',
];
